import { css } from 'styled-components';
import curry from 'lodash/curry';
import isEmpty from 'lodash/isEmpty';

import { calcMediaStyles } from './CalcMediaStyles/calcMediaStyles';
import { makeMediaObj } from './makeMediaObj';
import { VALID_MEDIA_MAP, VALID_MEDIA_STYLES, VALID_PICKED_MEDIA } from './common';

export const makeMediaStyles = curry((
  kind: string,
  style: VALID_MEDIA_STYLES,
) => {
  if (typeof style === 'string') {
    return css`
      ${kind}: ${style};
    `;
  }

  const pickedMedia: VALID_PICKED_MEDIA = makeMediaObj(style);

  if (!isEmpty(pickedMedia)) {
    return css`
      ${calcMediaStyles((pickedMedia as VALID_MEDIA_MAP), kind)};
    `;
  }
});
